enum ReportedTypes {
  ILLEGAL_CONTENT = 'Illegal Content',
  PORN_CONTENT = 'Pornographic Content',
  THREATS = 'Threats',
  OTHER = 'Other',
}

export default ReportedTypes;
